<template>
  <v-card v-model="editInstallationNotesDialog">
    <v-card>
      <v-card-title>Notes</v-card-title>
      <v-card-text>
        <quill-editor
          ref="quillEditor"
          class="editor"
          v-model="installationNotes"
          :options="editorOption"
        >
        </quill-editor>
        <br />
      </v-card-text>
      <v-card-actions class="mt-6">
        <v-spacer></v-spacer>
        <v-btn text @click="closeEditableBox()">Annuler</v-btn>
        <v-btn
          color="primary"
          @click="
            [updateInstallationNotes(clientPortal.id, installationNotes)];
            closeEditableBox();
          "
        >
          Enregistrer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-card>
</template>
<script>
import { ref, toRefs } from "@vue/composition-api";
import { useClientPortal } from "@/composables/client-portal";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

export default {
  props: {
    clientPortal: Object,
  },
  components: {
    quillEditor,
  },
  setup(props, { emit }) {
    const { updateInstallationNotes, data } = useClientPortal();
    const installationNotes = ref(props.clientPortal.installationNotes);
    const editorOption = ref({
      theme: "snow",
      modules: {
        toolbar: [
          ["bold", "strike"],
          ["code-block"],
          [{ header: [1, 2, 3, false] }],
          [{ color: [] }, { background: [] }],
          [{ list: "ordered" }, { list: "bullet" }],
          ["link"],
          ["clean"],
        ],
      },
    });

    function editor() {
      return quillEditor.quill;
    }
    quillEditor.quill;

    function closeEditableBox() {
      emit("closeEditeBox", true);
    }
    return {
      updateInstallationNotes,
      installationNotes,
      ...toRefs(data),
      quillEditor,
      editor,
      editorOption,
      closeEditableBox,
    };
  },
};
</script>

<style scoped>
.editor {
  height: 500px;
}
.noteBtn:hover {
  background-color: blue;
}
</style>
